import { render, staticRenderFns } from "./guest.vue?vue&type=template&id=354df93b&scoped=true"
import script from "./guest.vue?vue&type=script&lang=js"
export * from "./guest.vue?vue&type=script&lang=js"
import style0 from "./guest.vue?vue&type=style&index=0&id=354df93b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354df93b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreAppBar: require('/app/components/core/AppBar.vue').default,CoreView: require('/app/components/core/View.vue').default,CoreFooter: require('/app/components/core/Footer.vue').default})
